import { Button } from '@mui/material';
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
interface LogoutConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onLogout: () => void;
  loading: boolean;
}
export default function LogoutConfirmationModal({ open, onClose, onLogout, loading }: LogoutConfirmationModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Logout</DialogTitle>
      <DialogContent>
        <Typography variant="body2">Are you sure you want to logout? This action will sign you out of your account and you will need to login again to continue.</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onLogout} variant="contained" color="error" disabled={loading} loading={loading}>
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
}
